export const routers = {
  VEHICLE_INFO: 'vehicle-info',
  REGO_VEHICLE_INFO: 'rego/vehicle-info',
  PHOTO_UPLOAD: 'photo-upload'
};